/** @file Grab-item tool registration: title and activation chord G (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Moves a held item through the arm's IK. */
export const tool: ToolDef = { id: 'grabItem', title: 'tools.grabItem.title', bindings: [{ id: 'tool.grabItem', keys: 'KeyG', context: 'viewport' }] };
